import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { I18nTranslator } from '../i18n/translate';
import { FarmerAction, FarmerAuthorizationsService } from '../services/farmer-authorizations.service';
import { ModalService } from '../services/modal.service';
import { showErrorMessage } from './utils';

/** Blocks a creation/edition route the organisation withholds from a farmer-only user (C2027-196). */
export function farmerActionGuard(action: FarmerAction, redirectTo: string): CanActivateFn {
  return (): Observable<boolean | ReturnType<Router['createUrlTree']>> => {
    const farmerAuthorizationsService = inject(FarmerAuthorizationsService);
    const modal = inject(ModalService);
    const router = inject(Router);
    const i18nTranslator = inject(I18nTranslator);

    return farmerAuthorizationsService.can(action).pipe(
      map((allowed) => {
        if (allowed) {
          return true;
        }
        showErrorMessage(modal, i18nTranslator.translate('error.farmerActionForbidden'));
        return router.createUrlTree([redirectTo]);
      }),
    );
  };
}
